/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import {
    Button,
    Stack,
    Paper,
    Typography,
    Divider,
    Grid,
    Box
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Formik } from 'formik';
import get from "lodash/get";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";

import Layout from "../../../components/layout/Layout";
import Switch from "../../../components/form/Switch";
import InputText from "../../../components/form/InputText";
import Notification from "../../../components/form/Notification";
import NumericFormatPhone from "../../../components/form/FormatPhone";
import Alert from "../../../components/form/Alert";
import Skeleton from "../../../components/form/Skeleton";
import validator from "./validator";
import { useCanView } from "../../../config/hook/UserPermissions";

import { getConfiCostId } from "../../../store/masters/thunk/costGlobal/getId"
import { postConfiCost } from "../../../store/masters/thunk/costGlobal/post"
import { putConfiCost } from "../../../store/masters/thunk/costGlobal/put"

const NewEdit = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const canView = useCanView();
    const [__] = useTranslation("cost");
    const { id } = useParams();
    const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })
    const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" })

    const current = useSelector(state => state.masters.costGlobal.detail);
    const put = useSelector(state => state.masters.costGlobal.put);
    const post = useSelector(state => state.masters.costGlobal.post);

    const closeAlert = () => {
        setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
    }

    const setError = (err, action) => {
        if (!isEmpty(err) && !!get(err, "Message", "")) {
            setAlert({
                open: true,
                title: get(err, "Message", ""),
                subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        } else {
            setAlert({
                open: true,
                type: "default",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        }
    }

    useEffect(() => {
        if (get(post, "isSuccess", false)) { setShowNoti({ open: true, msg: "", variant: "success", action: "post" }); navigate(`/config/costs/${get(post, "id")}?from=new`); }
        if (get(post, "isReject", false)) { setError(get(post, "error", {}), "post") }
        if (get(put, "isSuccess", false)) { setShowNoti({ open: true, msg: "", variant: "success", action: "put" }); }
        if (get(put, "isReject", false)) { setError(get(put, "error", {}), "put") }
    }, [put, post])

    useEffect(() => {
        if (!!id) {
            dispatch(getConfiCostId({ id }))
        }
    }, [dispatch, id])

    const onSubmit = (values) => {
        if (canView("CONFIGURACIÓN/COSTOS", "update")){
            const baseBody = {
                nameCost: String(get(values, "nameCost")),
                description: String(get(values, "descriptionCost")),
                isActive: Boolean(get(values, "isActive")),
                odooProductInternal: get(values, "idCostOdoo") ? Number(get(values, "idCostOdoo")) : null,
            }

            if (id) { dispatch(putConfiCost({ idCost: Number(id), ...baseBody })) }
            else { dispatch(postConfiCost(baseBody)) }
        } else {
            setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para actualizar el costo.</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        }
    }

    const initialValues = {
        isActive: id ? get(current, "data.isActive", "") : true,
        nameCost: id ? get(current, "data.nameCost", "") : "",
        descriptionCost: id ? get(current, "data.description", "") : "",
        idCostOdoo: id ? get(current, "data.odooProductInternal", "") : "",
    }

    return (
        <Layout
            propsToolbar={{
                title: !id ? __(`head.new.name`) : __(`head.edit.name`),
                srute: !id ? __(`head.new.code`) : id
            }}
        >
            {get(current, "isLoading")
                ? (
                    <Skeleton />
                ) : (
                    <Formik initialValues={initialValues} validationSchema={validator(__)} onSubmit={onSubmit}>
                        {formik => (
                            <form onSubmit={get(formik, "handleSubmit")}>
                                <Paper className='p-4'>
                                    <Stack direction="row" spacing={2} justifyContent="flex-end">
                                        <LoadingButton className='w-[100px] min-w-[100px]' variant="contained" color="secondary" type="submit" loading={get(post, "isLoading") || get(put, "isLoading")}>{__(`action.save`)}</LoadingButton>
                                        <Button className='w-[100px] min-w-[100px]' variant='outlined' color="secondary" onClick={() => navigate("/config/costs")} disabled={get(post, "isLoading") || get(put, "isLoading")} >{__(`action.cancel`)}</Button>
                                    </Stack>
                                </Paper>

                                <Paper className='mt-4'>
                                    <Stack className='p-4' direction="row" spacing={2} justifyContent="space-between">
                                        <Typography component="h4" variant="h4">{__(`labels.1`)}</Typography>
                                        <Switch formik={formik} name="isActive" __={__} />
                                    </Stack>
                                    <Divider />
                                    <Box className='p-4' >
                                        <Grid container spacing={{ xs: 2, md: 3 }}>
                                            <Grid item xs={12} sm={6}>
                                                <InputText
                                                    formik={formik}
                                                    name="idCostOdoo"
                                                    label={__(`form.idCostOdoo.label`)}
                                                    placeholder={__(`form.idCostOdoo.placeholder`)}
                                                    disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                    InputProps={{
                                                        inputComponent: NumericFormatPhone,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <InputText
                                                    formik={formik}
                                                    name="nameCost"
                                                    label={__(`form.nameCost.label`)}
                                                    placeholder={__(`form.nameCost.placeholder`)}
                                                    disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <InputText
                                                    formik={formik}
                                                    name="descriptionCost"
                                                    label={__(`form.descriptionCost.label`)}
                                                    placeholder={__(`form.descriptionCost.placeholder`)}
                                                    disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                    multiline
                                                    rows={3}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Paper>
                            </form>
                        )}
                    </Formik>
                )}
            <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
            <Alert
                title={get(alert, "title")}
                subtitle={get(alert, "subtitle")}
                btn1={{ func: get(alert, "func") }}
                btn2={{}}
                type={get(alert, "type")}
                openAlert={get(alert, "open")}
                closeAlert={closeAlert}
            />
        </Layout>
    )
}

export default NewEdit